import React from 'react';
import { Dialog, Grid, Typography, Button } from '@mui/material';
import {
  Ellipse,
  Redwarning,
} from 'component/BuyersMarketplace/Marketplaceicons';
import { poppins500, poppins400 } from 'theme/common.style';

const PrivateOfferCancelled = ({
  openCancelled,
  setOpenCancelled,
  getBuyerIndividualValue,
  isSmallHeight,
  matchessm,
  onClose,
  setManageOffer,
  groupIt,
  groupCall,
}) => {
  return (
    <Dialog
      open={openCancelled}
      PaperProps={{
        sx: {
          height: isSmallHeight ? '460px' : matchessm ? 'auto' : '650px',
          borderRadius: '8px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          padding: matchessm ? '20px' : '30px',
        },
      }}
      zIndex={200000}
    >
      <Grid container>
        <Grid item>
          <Typography
            sx={{
              fontFamily: 'poppins!important',
              fontSize: matchessm ? '10px' : '14px!important',
              fontWeight: 400,
              color: '#666666',
            }}
          >
            {
              getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                ?.streetName
            }
          </Typography>

          <Grid item display={'flex'} alignItems={'center'}>
            <Redwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                color: '#000000',
              }}
            >
              <Grid
                item
                display={'flex'}
                alignItems={'center'}
                padding={'12px 0px 15px 0'}
              >
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchessm ? '16px' : '24px',
                    paddingLeft: '8px',
                    color: '#000000',
                  }}
                >
                  Offer Cancelled
                </Typography>
              </Grid>
            </Typography>
          </Grid>
          <Grid>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchessm ? '12px' : '16px!important',
                fontWeight: 400,
                color: '#666666',
                justifyContent: 'center',
                alignItems: 'center',

                marginTop: '0px',
                marginLeft: '3px',
                justifyItems: 'self-end',
              }}
            >
              Vendor accepted private offer has been cancelled.
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            paddingTop: matchessm ? '30px' : '40px',
            marginTop: '10px',
            borderTop: '1px solid #D9D9D9',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Ellipse isSmallHeight={isSmallHeight} />
        </Grid>

        <Grid
          container
          gap={2}
          marginTop={matchessm ? '30px' : '40px'}
          justifyContent={'end'}
        >
          <Grid item sx={{ marginTop: '8px' }}></Grid>
          <Grid item>
            <Button
              variant="outlined"
              style={{
                padding: '10px 39px',
                width: '100%',
                height: '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
              }}
              onClick={() => {
                setOpenCancelled(false);
                onClose();
                setManageOffer();
                groupIt();
                groupCall();
              }}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};
export default PrivateOfferCancelled;
